import React from 'react';
import { useTranslation } from 'react-i18next';
import TextInput from '@wix/da-ds/pkg/formControls/dsPresets/TextInput';
import { useSubmitField } from '../../../hooks/useSubmitField';

const DownloadUrlField: React.FC<{}> = () => {
  const { t } = useTranslation();
  const {
    id,
    field: { ref, ...inputProps },
  } = useSubmitField('downloadUrl', {
    initAdapter: ({ app }) => app?.downloadUrl ?? '',
    submitAdapter: ({ downloadUrl }) => ({ download_url: downloadUrl }),
  });

  return (
    <TextInput
      id={id}
      ref={ref}
      label={t('deviationSubmit.form.app.downloadUrl.label')}
      subLabel={t('deviationSubmit.form.app.downloadUrl.hint')}
      placeholder={t('deviationSubmit.form.app.downloadUrl.placeholder')}
      {...inputProps}
    />
  );
};
DownloadUrlField.displayName = 'DownloadUrlField';

export default DownloadUrlField;
